import positiveNumber from 'src/utils/validations/positiveNumber';

const timestamp = {
  base: positiveNumber.base
};
timestamp.required = timestamp.base.required('errorMessages.required');
timestamp.optional = positiveNumber.optional;

export default timestamp;
